import { CsvProvider } from './provider/CSVProvider';
import RilaCalculator from './pages/RilaCalculator';
import Navbar from './navbar/Navbar';
import OptionsDisplay from './pages/OptionsDisplay';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "react-oidc-context";
import './App.css';
import AuthRedirect from './pages/AuthRedirect';

function App() {

  const cognitoAuthConfig = {
    authority: process.env.REACT_APP_PROVIDER_URL,
    client_id: process.env.REACT_APP_CLIENT_ID,
    redirect_uri: `https://${process.env.REACT_APP_DOMAIN_NAME}/redirect`,
    response_type: "code",
    scope: `${process.env.REACT_APP_API_DOMAIN}/file-handler email openid profile`,
  };

  return (
    <AuthProvider {...cognitoAuthConfig}>
      <CsvProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<RilaCalculator />} />
            <Route path="/calculator" element={<RilaCalculator />} />
            <Route path="/redirect" element={<AuthRedirect />} />
            <Route path="/rates" element={<OptionsDisplay />} />
          </Routes>
        </BrowserRouter>
      </CsvProvider>
    </AuthProvider>
  );
}

export default App;
